import { EmptyState, TrustBadge } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { FileWarning, ScrollText } from "lucide-react";

export default function AuditRights({ rights, audit, onResolve }) {
  return (
    <div className="space-y-6" data-testid="admin-audit">
      <div>
        <h3 className="text-sm font-semibold mb-3 flex items-center gap-2"><FileWarning className="h-4 w-4 text-rose-400" /> Data rights requests</h3>
        {rights.length === 0 ? <EmptyState icon={FileWarning} title="No rights requests" /> : (
          <div className="rounded-xl border border-border bg-card divide-y divide-border overflow-hidden">
            {rights.map((r) => (
              <div key={r.id} className="flex items-center gap-3 p-4" data-testid={`right-${r.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{r.subject}</div>
                  <div className="text-xs text-muted-foreground capitalize">{r.type.replace(/_/g, " ")}</div>
                </div>
                {r.status === "pending" ? (
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline" onClick={() => onResolve(r.id, "resolved")} data-testid={`resolve-${r.id}`}>Fulfil</Button>
                    <Button size="sm" variant="ghost" onClick={() => onResolve(r.id, "rejected")} data-testid={`reject-right-${r.id}`}>Reject</Button>
                  </div>
                ) : <TrustBadge type={r.status === "resolved" ? "high" : "flag"}>{r.status}</TrustBadge>}
              </div>
            ))}
          </div>
        )}
      </div>
      <div>
        <h3 className="text-sm font-semibold mb-3 flex items-center gap-2"><ScrollText className="h-4 w-4 text-primary" /> Audit log</h3>
        <div className="rounded-xl border border-border bg-card divide-y divide-border overflow-hidden">
          {audit.map((a) => (
            <div key={a.id} className="flex items-start gap-3 p-3.5 text-sm" data-testid={`audit-${a.id}`}>
              <div className={`h-2 w-2 rounded-full mt-1.5 shrink-0 ${a.severity === "warning" ? "bg-amber-400" : "bg-emerald-400"}`} />
              <div className="flex-1 min-w-0">
                <div><span className="font-medium">{a.actor_name}</span> <span className="text-muted-foreground">· {a.action}</span> → {a.target}</div>
                {a.detail && <div className="text-xs text-muted-foreground">{a.detail}</div>}
              </div>
              <span className="text-[11px] font-mono text-muted-foreground shrink-0">{new Date(a.timestamp).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
